import { logger as baseLogger } from "matrix-js-sdk/src/logger";
import { useState, useEffect, type DependencyList } from "react";

const logger = baseLogger.getChild("useAsyncMemo");

type Fn<T> = () => Promise<T>;

export function useAsyncMemo<T>(fn: Fn<T>, deps: DependencyList, initialValue: T): T;
export function useAsyncMemo<T>(fn: Fn<T>, deps: DependencyList, initialValue?: T): T | undefined;
export function useAsyncMemo<T>(fn: Fn<T>, deps: DependencyList, initialValue?: T): T | undefined {
    const [value, setValue] = useState<T | undefined>(initialValue);
    useEffect(() => {
        let discard = false;
        fn().then((v) => {
            if (!discard) {
                setValue(v);
            }
        }).catch((err) => {
            if (!discard) {
                logger.error("async function rejected", err);
            }
        });
        return () => {
            discard = true;
        };
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps
    return value;
}
